import {errorHandler, message, logout, getCountryByCode, getNewCount, copyElement, loader} from '@/libs/helper'
import {getCollectionDossierCount, collectionFilterData, getCollectionInfo, getDossierInfo, dossierFilterData, createShortUrl, getShortUrl, getFollowersCount, getUserProfile, updateFavourite, checkStripeAccountStatus} from '@/libs/api/api'
import constants from '@/libs/constant/constants'
import {cloneDeep, isEmpty} from 'lodash'
import { mapGetters }  from 'vuex';
import permissions from '@/libs/constant/permissions'

export default{
    components: {
        donatePopup: () => import('@/components/component/Reuse/DonateDialog/DonateDialog.vue')
    },
    created() {
        if (this.$route.name === 'user-collections-page' || this.$route.name === 'user-collection-about-page') {
            this.isCollection = true
            this.getCollectionFilterData(true)
        }
        else if (this.$route.name === 'user-dossiers-page' || this.$route.name === 'user-dossier-about-page') {
            this.isCollection = true
            this.isDossier = true
            this.getDossierFilterData(true)
        }
        // to refresh menu if noting matches
        else {
            this.refreshMenu()
        }
    },
    computed: {
        ...mapGetters(['hasPermission'])
    },
    mounted(){
        this.fetchMetaDetails()
    },
    props: {
        userInformation: {
            type: Object,
            default: () => {}
        },
        activateSharePopup: {
            type: Function,
            default: () => {}
        },
        handleClose: {
            type: Function,
            default: () => {}
        },
        updateArticleShareCount: {
            type: Object,
            default: () => {}
        },
        changeUpdateArticleShareCount: {
            type: Function,
            default: () => {}
        }
    },
    watch: {
        '$route' (to, from) {
            if (to.params && to.params.id && from.params && from.params.id && to.params.id !== from.params.id) {
                this.fetchMetaDetails()
            } 
            if (to.name === 'user-collections-page' || to.name === 'user-collection-about-page') {
                this.isCollection = true
            }
            else if (to.name === 'user-dossiers-page' || to.name === 'user-dossier-about-page') {
                this.isCollection = true
                this.isDossier = true
            }
            else {
                this.refreshMenu()
            }
        },
        userInformation (newValue) {
            if (this.$route.params.id !== newValue.id) this.details = newValue
        }
    },
    data(){
        return {
            copyElement,
            getNewCount,
            isEmpty,
            details: {},
            counts:[],
            module: 'USER',
            getCountryByCode: getCountryByCode,
            activeName: 'zero',
            articles: [],
            articlesToDisplay: [],
            sortAs: 'Most recent',
            viewKey: 1,
            shortUrl: '',
            collectionShortUrl: '',
            isCollection: false,
            isDossier: false,
            selectedRecord: {},
            manageList: [],
            selectedValue: '',
            activeMenu: 'Profile',
            collectionCount: 0,
            dossierCount: 0,
            collectionFollowersCount: 0,
            collectionArticleCount: 0,
            isShare: false,
            articleToShare: {},
            shareType: '',
            showDonate: false,
            stripeAccountDetails: {},
            permissions: permissions
        }
    },
    methods:{
        getIconClassName(media){
            switch (media.type){
                case 'TWITTER':
                    return 'nova-twitter-icon'
                case 'FACEBOOK':
                    return 'nova-facebook'
                case 'LINKEDIN':
                    return 'nova-linkedin'
            }
        },
        /**
         * method to hit all the api's t get initial data
         */
        fetchMetaDetails () {
            this.fetchDetails()
            this.getCollectionCount()
            this.getCollectionCount(true)
            this.getDetailShortUrl()
        },
        /**
         * to get the user info
         */
        async fetchDetails() {
            try {
                if ((this.$route.params.id !== this.$store.getters.getUserInformation.id) || (this.userInformation && this.userInformation.id &&  this.userInformation.id !== this.$route.params.id)) {
                    this.details = await getUserProfile({user_id: this.$route.params.id})
                }
                else {
                    this.details = (this.userInformation) || (this.$store.getters.getUserInformation) || {}
                }
            } catch (error) {
                console.error(error)
            }
        },
        /**
         * route to detail page of A/P/P
         * @param {*} record 
         * @param {*} type 
         */
        routeToDetailPage(record, type){
            this.$router.push(`/ip/${type.toLowerCase()}s/${record.publication || record._id}/`).catch(() => {})
        },
        /**
         * route to detail page of A/P/P
         */
        routeFromCollectionPage (record, type) {
            this.$router.push(`/ip/${type.toLowerCase()}s/${record.author_id || record.publication_id || record.publisher_id}/`).catch(() => {})
        },
        getURL(imageName){
            return `${process.env.VUE_APP_API_BASE_URL}/accounts/files/${imageName}?auth=${localStorage.getItem('accuraAuthToken')}`
        },
        /*
         * return the place holder image in case of error in image loading.
         * */
        onError(e) {
            let avatarURL = require('@/assets/images/author_placeholder.png');
            if (e.target.src !== avatarURL) {
                e.target.src = avatarURL;
            }
        },

        /**
         * to get the count of collection
         */
        getCollectionCount (isDossier) {
            // body for api
            let body = {
                entity_id: this.$route.params.id,
                entity_type: this.module,
                count_for: 'COLLECTION'
            }
            if (isDossier) body.count_for = 'DOSSIER'
            // api call
            getCollectionDossierCount(body).then(response => {
                if (isDossier) this.dossierCount = (response.count || 0)
                else this.collectionCount = (response.count || 0)
            }).catch(error => error)
        },

        /**
         * route to author detail page 
         */
        routeToAuthors () {
            this.$router.push({name: 'user-about'}).catch(() => {})
        },

        /**
         * update article count whenever page 
         * lands on article page > latest tab
         */
        updateArticleCount (count) {
            // update articles count
            if (count !== undefined && count !== null) this.articlesCount = count
        },
        /**
         * update the router key to route on the same route
         */
        updateViewKey () {
            this.viewKey +=1
            // this.updateLeftMenu(false, {})
        },
        /**
         * to update the left side menu
         * @param {*} isCollection true/false
         * @param {*} item item to show
         */
        updateLeftMenu (isCollection, item) {
            this.selectedRecord = cloneDeep(item)
            this.isCollection = true
            if (isCollection) {
                this.getCollectionFilterData()
            } 
            else if (!isCollection) {
                this.getDossierFilterData()
            }
        },
        /**
         * to get the collection filter data
         */
        getCollectionFilterData:async function (isTrue) {
            try {
                // to get the short url
                this.getShortUrlCollection()
                // to get the followers count
                this.getCollectionDossierFollowersCount()
                let cid = this.$route.params.cid
                if (isTrue) {
                    let result = await getCollectionInfo(cid)
                    this.selectedRecord = result
                }
                let response = await collectionFilterData({collection_id: cid})
                // set collection filter data
                this.setCollectionFilterData(response)
                } catch (error) {
                    console.error(error)
                    message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
                }
        },
        /**
         * to set the filter data
         * @param {*} data 
         */
        setCollectionFilterData (data) {
            // to set is_following key of authors
            if (data && data.authors && !isEmpty(data.authors)) {
                data.authors = data.authors.map(author => {
                    author.is_following = false
                    if (data.followings && data.followings.author_following && !isEmpty(data.followings.author_following) && new Set(data.followings.author_following).has(author.author_id)) author.is_following = true
                    return author
                })
                this.$set(this.selectedRecord, 'authors', data.authors || [])
            }
            // to set is_following for publications
            if (data && data.publications && !isEmpty(data.publications)) {
                data.publications = data.publications.map(publication => {
                    publication.is_following = false
                    if (data.followings && data.followings.publication_following && !isEmpty(data.followings.publication_following) && new Set(data.followings.publication_following).has(publication.publication_id)) publication.is_following = true
                    return publication
                })
                this.$set(this.selectedRecord, 'publications', data.publications || [])
            }
            // to set is_following for publishers
            if (data && data.publishers && !isEmpty(data.publishers)) {
                data.publishers = data.publishers.map(publisher => {
                    publisher.is_following = false
                    if (data.followings && data.followings.publisher_following && !isEmpty(data.followings.publisher_following) && new Set(data.followings.publisher_following).has(publisher.publisher_id)) publisher.is_following = true
                    return publisher
                })
                this.$set(this.selectedRecord, 'publishers', data.publishers || [])
            }
        },
        /**
         * to get the collection filter data
         */
        getDossierFilterData:async function (isTrue) {
            try {
                this.isDossier = true
                // to get the short url
                this.getShortUrlCollection()
                // to get the followers count
                this.getCollectionDossierFollowersCount()
                let did = this.$route.params.did
                if (isTrue) {
                    let result = await getDossierInfo(did)
                    this.selectedRecord = result
                }
                let response = await dossierFilterData({dossier_id: did})
                // set collection filter data
                this.setCollectionFilterData(response)
                } catch (error) {
                    message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
                }
        },

        /**
         * to refresh the left side menu
         */
        refreshMenu () {
            this.isCollection = false
            this.isDossier = false
        },

        /**
         * to get the short url
         */
        getDetailShortUrl (isCreate) {
            let body = {
                type: this.module,
                type_id: this.$route.params.id,
                user: this.$route.params.id
            }
            if (isCreate) {
                if (!this.hasPermission(permissions.createShortUrl)) return;
                createShortUrl(body).then(response => {
                    this.shortUrl = response.short_url || ''
                }).catch(error => {
                    console.error(error)
                })
            } else {
                if (!this.hasPermission(permissions.getShortUrl)) return;
                getShortUrl(body).then(response => {
                    this.shortUrl = response.short_url || ''
                }).catch(error => {
                    console.error(error)
                })
            }
        },
        /**
         * api call to get the collection/dossier short url
         */
        getShortUrlCollection (isCreate) {
            // body for api call
            let body = {
                type: this.module,
                type_id: this.$route.params.id,
                sub_type: 'COLLECTION',
                sub_type_id: this.$route.params.cid,
                user: this.$route.params.id
            }
            if (this.isDossier) {
                body.sub_type = 'DOSSIER'
                body.sub_type_id = this.$route.params.did
            }
            // short url is create 
            if (isCreate) {
                // api call
                createShortUrl(body).then(response => {
                    this.collectionShortUrl = response.short_url || ''
                }).catch(error => {
                    console.error(error)
                })
            }
            // to get short url
            else {
                // api call
                getShortUrl(body).then(response => {
                    this.collectionShortUrl = response.short_url || ''
                }).catch(error => {
                    console.error(error)
                })
            }
        },
        /**
         * route to collection about page
         */
        routeToCollectionAboutPage (query) {
            if (this.isDossier) {
                if (query !== '' && query !== null && query !== undefined) {
                    this.$router.push({name: `user-dossier-about-page`, query: {type: query}}).catch(() => {})
                } else {
                    this.$router.push({name: `user-dossier-about-page`}).catch(() => {})
                }
            } else {
                if (query !== '' && query !== null && query !== undefined) {
                    this.$router.push({name: `user-collection-about-page`, query: {type: query}}).catch(() => {})
                } else {
                    this.$router.push({name: `user-collection-about-page`}).catch(() => {})
                }
            }
            
        },
        /**
         * to get the count of followers of collection/dossier
         */
        getCollectionDossierFollowersCount () {
            // body for api
            let body = {
                entity_type: this.isDossier ? constants.LIST.DOSSIER : constants.LIST.COLLECTION,
                entity_id: this.isDossier ? this.$route.params.did : this.$route.params.cid
            }
            // api call
            getFollowersCount(body).then(response => {
                this.collectionFollowersCount = response.count || 0
            }).catch(error => {
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
            })
        },
        /**
         * to update the count of 
         * @param {*} meta 
         * @param {*} type 
         */
        updateCollectionMetaList (meta, type) {
            // if result matches the detal page of A/P/P then update the is_folllow
            if (meta.data && meta.data._id === this.details._id) {
                this.details.is_following = meta.is_following
            }
            switch (type) {
                case constants.AUTHOR.key:
                    this.selectedRecord.authors = this.selectedRecord.authors.map(author => {
                        if (meta.data && meta.data._id === author._id) author.is_following = meta.is_following
                        return author
                    })
                break
                case constants.PUBLICATION.key:
                    this.selectedRecord.publications = this.selectedRecord.publications.map(publication => {
                        if (meta.data && meta.data._id === publication._id) publication.is_following = meta.is_following
                        return publication
                    })
                break
                case constants.PUBLISHER.key:
                    this.selectedRecord.publishers = this.selectedRecord.publishers.map(publisher => {
                        if (meta.data && meta.data._id === publisher._id) publisher.is_following = meta.is_following
                        return publisher
                    })
                break
            }
        },
        /*
         * to route to collection page
         */
        routeToCollectionPage () {
            // route to dossier
            if (this.isDossier) this.$router.push({name: `user-dossiers`}).catch(() => {})
            // route to collection
            else this.$router.push({name: `user-collections`}).catch(() => {})
            // to refresh the menu
            this.refreshMenu()
        },

        /**
         * to update the count of followers
         * @param {*} item 
         */
        updateCount (type, item) {
            switch (type) {
                case constants.LIST.COLLECTION:
                    this.collectionFollowersCount = item.count || 0
                break
                case constants.LIST.COLLECTION_ARTICLES:
                    this.collectionArticleCount = item
                break
            }  
        },
        /**
         * route to about page
         * @param {*} query where to route
         * @param {*} isCollection iscollection true/false
         */
        routeToFollowers (query, isCollection) {
            if (isCollection) {
                let name = this.isDossier ? `user-dossier-about-page` : `user-collection-about-page`
                this.$router.push({name: name, query: {type: query}}).catch(() => {})
            } else {
                this.$router.push({name: `user-about`, query: {type: query}}).catch(() => {})
            }
        },
        /**
         * to get the favorite for A/P/P and collection/dossier
         * @param {*} isCollection true(to check for collection/dossier) 
         */
        getFavorite (isCollection) {
            // to check for collection/dossier
            if (isCollection && this.selectedRecord && this.selectedRecord.favorites && new Set(this.selectedRecord.favorites).has(this.$store.getters.getUserInformation.id)) return true
            // to check for detail page(A/P/P)
            else if (!isCollection && this.details && this.details.favorites && new Set(this.details.favorites).has(this.$store.getters.getUserInformation.id)) return true
            else return false
        },
        /**
         * create/delete favorite for collection and dossier
         */
        async setCollectionFavorite () {
            try {
                loader(this, true)
                // body for api
                let isRemove = this.getFavorite(true)
                let body = {
                    entity_type: this.isDossier ? constants.LIST.DOSSIER : constants.LIST.COLLECTION,
                    entity_id: this.$route.params.cid
                }
                // api call
                let response = await updateFavourite(body, isRemove ? 'remove-favorite' : 'favorite')
                this.$set(this.selectedRecord, 'favorites', response.result.favorites || [])
                message(this, constants.messageType.SUCCESS, !isRemove ? 'marked_favorite' : 'removed_favorite')
                loader(this, false)
            } catch (error) {
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
                loader(this, false)
            }
        },
        /**
         * to close the donate popup
         */
        async showDonatePopup () {
            try {
                loader(this, true)
                // body for api
                let body = {
                    entity_type: this.module,
                    entity_id: this.$route.params.id
                }
                // api call
                let response = await checkStripeAccountStatus(body)
                // set account status
                this.stripeAccountDetails = response || {}
                if (!response.details_submitted) {
                    message(this, constants.messageType.ERROR, 'Connected account details not submitted')
                } else {
                    // open donate popup
                    this.showDonate = true
                }
            } catch (error) {
                console.error(error)
            } finally {
                loader(this, false)
            }
        },
        /**
         * to close donate popup
         */
        closeDonatePopup () {
            this.showDonate = false
        }
    }
}